import React, { PropsWithChildren, ReactElement, useId } from 'react';
import styled, { css } from 'styled-components';
import { Tooltip } from 'primereact/tooltip';

interface ComponentProps {
  label: string;
  icon?: ReactElement;
}

export const LabeledChildren: React.FC<PropsWithChildren<ComponentProps>> = ({
                                                                               label,
                                                                               icon,
                                                                               children,
                                                                             }) => {
  return (
    <Grid>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <Content>
        <LabelContainer>
          <Label>
            {label}
          </Label>
        </LabelContainer>
        <ContentInner>{children}</ContentInner>
      </Content>
    </Grid>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 0.5rem;
`;

const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const LabelContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin: 0.5rem 0;
`;

const Label = styled.div`
  color: var(--content-secondary, #616061);

  /* Small Medium */
  font-family: "DM Sans", serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 85.714% */
`;


const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
